import React from 'react';
import { BackButton, OutlinedIcons } from '@marageti/z4-lib';
import { ResponsiveSubNavigation } from '../sub-navigation';

export type BackNavigationViewProps = {
  /** Text displayed in the navigation bar (e.g. "My Trips", "My Profile") */
  primaryText: string;
  /** Callback invoked when the back button is clicked */
  handleBack: () => void;
  /** E2E test identifier for the back button */
  dataE2e?: string;
};

/**
 * Presentational back-navigation bar: compact mobile view + back button.
 * Consumer is responsible for calling useBackNavigation to resolve primaryText and handleBack.
 */
const BackNavigationView = ({ primaryText, handleBack, dataE2e }: BackNavigationViewProps) => (
  <ResponsiveSubNavigation
    profile={{ primary: primaryText }}
    startAdornment={(
      <BackButton data-e2e={dataE2e} onClick={handleBack} edge="start">
        <OutlinedIcons.OutlinedArrowSmLeftIcon color="primary" />
      </BackButton>
    )}
  />
);

export default BackNavigationView;
